<template>
    <BreadCrumb PageTitle="Liste des années" />
    <ListeAnneeAcademique />
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import ListeAnneeAcademique from "../../components/AnneeAcademique/ListeAnneeAcademique.vue";

  
    export default defineComponent({
      name: "ListeAnneeAcademiquePage",
      components: {
        BreadCrumb,
        ListeAnneeAcademique,
      },
    });
  </script>